import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import TypesService from '../../services/TypesService';
import Icon, { Icons } from '../Icon/Icon';
import ListItem from '../ListItem';

import AppConfig from '../../config';
import './FeeItem.scss';

const LOADING_ICON_SIZE = 24;

const CREDIT_CURRENCY = AppConfig?.creditCurrency ?? 'Credits';
const BlockchainsById = TypesService.BlockchainsById;
const CurrenciesById = TypesService.CurrenciesById;
const CREDIT_CURRENCY_ID = 8;

const creditIconNode = AppConfig?.creditCurrencyIcon ? (
	<img src={AppConfig.creditCurrencyIcon} alt={AppConfig.creditCurrency} width={40} height={40} />
) : (
	CREDIT_CURRENCY
);

const FeeItem = ({ feeData, onClick = () => {}, lowBalanceText = '', trailing = [] }) => {
	const quotes = useSelector(store => store.app.quotes);

	const currencyRate = quotes.find(quote => quote.Id === feeData.CurrencyId)?.Rate || 0;

	const gsBalance = feeData.GsBalance || 0;
	const lowBalance = feeData.Amount < feeData.Fee && gsBalance < feeData.Fee;

	const currencyData = CurrenciesById[feeData.CurrencyId] || {};
	const currencyBlockchainData = BlockchainsById[currencyData.BlockchainId] || {};
	const showLowBalanceText = lowBalance && !!lowBalanceText;

	const onSelect = () => {
		if (lowBalance) return;

		onClick(feeData);
	};

	console.log('currencyData.CompanyIcon', currencyData.CompanyIcon);

	const loadingIcon = <Icon type={Icons.LOADING_SPINNER} width={LOADING_ICON_SIZE} height={LOADING_ICON_SIZE} />;

	return (
		<div className='FeeItem'>
			<ListItem
				className={classNames('FeeItem', 'FormBlock', {
					['FeeItem__low-balance']: lowBalance,
					['FeeItem__show-low-balance-text']: showLowBalanceText,
				})}
				icon={feeData.CurrencyId === CREDIT_CURRENCY_ID ? creditIconNode : currencyData.CompanyIcon}
				iconLabel={currencyData.CompanyIcon !== currencyBlockchainData.Icon ? currencyBlockchainData.Icon : null}
				title={feeData.CurrencyId === CREDIT_CURRENCY_ID ? CREDIT_CURRENCY : currencyData.Name}
				label={currencyBlockchainData.Name || null}
				description={
					<>
						{t('Balance')} {HelperService.FormatCrypto(feeData.Amount, currencyData.Precision, 'floor')}
					</>
				}
				rightTitle={feeData.Loading ? loadingIcon : HelperService.FormatCrypto(feeData.Fee, currencyData.Precision)}
				rightDescription={
					feeData.Loading ? null : '$' + HelperService.FormatFiatWithoutCurrency(feeData.Fee * currencyRate)
				}
				onSelect={onSelect}
				trailing={trailing}
			/>
			{showLowBalanceText && <div className='FeeItem__low-balance-text'>{t(lowBalanceText)}</div>}
		</div>
	);
};

FeeItem.propTypes = {
	feeData: PropTypes.object,
	onClick: PropTypes.func,
	trailing: PropTypes.array,
};

export default FeeItem;
